<!--
  - Copyright Huesik (c) 2019.
  -->

<template>
  <main-layout classes="interest-view">
    <main-menu-header/>
    <div class="interest-header-container">
      <div class="interest-header">
        <h1>관심목록</h1>
        <nav>
          <li @click="moveTab('lastView')" :class="{on: currentTab === 'lastView'}">최근 본 고시원</li>
          <li @click="moveTab('pick')" :class="{on: currentTab === 'pick'}">찜한 고시원</li>
        </nav>
      </div>
    </div>

    <div class="interest-list-container" :class="{'no-data': (currentTab === 'lastView' && lastViewList.length === 0) || (currentTab === 'pick' && pickList.length === 0)}">
      <transition name="fade" mode="out-in">
        <div :key="`fade1`" v-if="currentTab === 'lastView'" class="margin-auto">
          <div class="interest-list flex align-center" v-if="lastViewList.length > 0">
            <div v-for="lastView in lastViewList" :key="`__LAST_VIEW__${lastView.pk}`" class="interest-item"
                 @click="moveToDetail(lastView.pk)">
              <div class="kosiwons-image-wrapper">
                <img :src="lastView.thumbnail_url ? lastView.thumbnail_url : SampleImage" @error="showErrorImage"/>
              </div>
              <kosiwon-information-fragments
                :kosiwon-information="lastView"
              />
            </div>
          </div>
          <div class="no-data-view" :key="`fade2`" v-else >
            <img src="../assets/images/ex-graylogo.png"/>
            <p>최근 본 고시원 목록이 없습니다.</p>
          </div>
        </div>
        <div v-else class="margin-auto">
          <div class="interest-list flex align-center" v-if="pickList.length > 0">
            <div v-for="pick in pickList" :key="`__PICK__${pick.pk}`" class="interest-item" @click="moveToDetail(pick.pk)">
              <div class="kosiwons-image-wrapper">
                <img :src="pick.thumbnail_url ? pick.thumbnail_url : SampleImage" @error="showErrorImage"/>
              </div>
              <kosiwon-information-fragments
                :kosiwon-information="pick"
              />
            </div>
          </div>
          <div class="no-data-view" v-else>
            <img src="../assets/images/ex-graylogo.png"/>
            <p>찜한 고시원 목록이 없습니다.</p>
          </div>
        </div>
      </transition>
    </div>
    <default-footer></default-footer>
  </main-layout>
</template>

<script>
  import MainLayout from '../components/Layout/MainLayout'
  import MainMenuHeader from '../components/Header/MainMenuHeader'
  import DefaultFooter from '../components/Footer/index'
  import KosiwonInformationFragments from '../components/Kosiwons/KosiwonInformationFragments'
  import SampleImage from '../assets/images/img-5542.png'

  import {mapState} from 'vuex'
  import DynamicNavigator from '../core/modules/DynamicNavigator'

  export default {
    name: 'Interest',
    components: {KosiwonInformationFragments, DefaultFooter, MainMenuHeader, MainLayout},
    data() {
      return {
        currentTab: 'lastView',
        SampleImage
      }
    },
    computed: {
      ...mapState({
        lastViewList: state => state.INTEREST.LAST_VIEW_LIST,
        pickList: state => state.INTEREST.PICK_LIST
      })
    },
    methods: {
      moveToDetail(pk) {
        console.log(pk)
        let routeData = this.$router.resolve(`/detail/${pk}`)
        DynamicNavigator.getInstance().moveToDetail(routeData.href, this.$router)
      },
      moveTab(target) {
        this.currentTab = target
      },
      showErrorImage (event) {
        event.target.src = SampleImage
      }
    }
  }
</script>

<style scoped lang="less">
  @import "../assets/css/palette";

  .interest-view {
    overflow: auto;
    .interest-header-container {
      background: @white;

      .interest-header {
        max-width: 120rem;
        min-width: 120rem;
        margin: auto;

        h1 {
          padding: 7.7rem 0 3.3rem;
          font-size: 3rem;
          font-weight: bold;
        }

        nav {
          li {
            display: inline-block;
            width: 50%;
            font-size: 2rem;
            font-weight: bold;
            padding: 1.5rem 0;
            color: @brown-grey;
            border-bottom: 2px solid @very-light-pink-two;
            box-sizing: border-box;

            &.on {
              color: @windows-blue-two;
              border-bottom-color: @windows-blue-two;
            }
          }
        }
      }
    }

    .interest-list-container {
      padding: 1.5rem 0 3rem;
      background: @very-light-pink;
      min-height: 60rem;
      display: flex;

      &.no-data {
        justify-content: center;
        align-items: center;
      }

      .interest-list {
        max-width: 120rem;
        min-width: 120rem;
        margin: 0 auto;
        flex-wrap: wrap;

        .interest-item {
          width: 25%;
          padding: 1.5rem 2rem;
          box-sizing: border-box;
          cursor: pointer;

          .kosiwons-image-wrapper {
            height:100%;
            width: 100%;
            overflow: hidden;
            position: relative;
            padding-top: 66%;

            img {
              position: absolute;
              margin: auto;
              min-height: 100%;
              min-width: 100%;
              width:100%;

              /* For the following settings we set 100%, but it can be higher if needed
              See the answer's update */
              left: -100%;
              right: -100%;
              top: -100%;
              bottom: -100%;
            }
          }
        }
      }
      .no-data-view {
        padding: 5rem;
        width: 100%;
        text-align: center;

        img {
          display: block;
          margin: 0 auto;
        }
        p {
          margin: 1.5rem 0;
          color: @brown-grey;
        }
      }
    }
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .3s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
</style>
<style scoped lang="less">
  @import "../assets/css/palette";
  @media screen and (max-width: 1366px) {
    .interest-view {
      .interest-header-container {
        .interest-header {
          max-width: 100rem;
          min-width: 100rem;
        }
      }

      .interest-list-container {
        .interest-list {
          max-width: 100rem;
          min-width: 100rem;

          .interest-item {
            padding: 1rem 1rem;
          }
        }
      }
    }
  }
</style>
<style scoped lang="less" >
  @import "../assets/css/palette";
  /* Medium devices (landscape tablets, 768px and up) */
  @media screen and (max-width: 768px) {
    .interest-view {
      .interest-header-container {
        .interest-header {
          min-width: initial;
          h1 {
            padding: 3rem 0 2.5rem;
            font-size: 2rem;
          }
          nav {
            li {
              font-size: 1.5rem;
            }
          }
        }
      }
      .interest-list-container {
        min-height: 40rem;
        .interest-list {
          width: calc(100vw - 3rem);
          min-width: initial;
          justify-content: space-between;
          padding: 0 1.5rem;
          .interest-item {
            width: calc(50% - 0.5rem);
            padding-top: 1.5rem ;
            cursor: pointer;
            &:nth-child(2n-1) {
              padding-right: 0.5rem;
              padding-left: 0;
            }
            &:nth-child(2n) {
              padding-left: 0.5rem;
              padding-right: 0;
            }

            .kosiwons-image-wrapper {
              img {
                width: 100%;
              }
            }
          }
        }
        .no-data-view {
          padding: 1rem;
          img {
            max-width: 50%;
          }
        }
      }
    }
  }
</style>
